// =============================================================================
// File-input attach UI. Markup:
//
//   <div class="… js-attachField">
//     <label><span>Browse</span><input type="file" class="js-attachInput" …></label>
//     <span><span class="js-attachName">Attach a file</span>
//           <button class="js-attachRemove" hidden>&times;</button></span>
//   </div>
//
// On change → swap placeholder for filename + reveal remove button. Click
// remove → clear input + restore placeholder.
// =============================================================================
(function ($) {
    'use strict';

    const PLACEHOLDER = 'Attach a file';

    function refresh($input) {
        const $field   = $input.closest('.js-attachField');
        const $name    = $field.find('.js-attachName');
        const $remove  = $field.find('.js-attachRemove');
        const file     = $input[0].files && $input[0].files[0];

        if (file) {
            $name.text(file.name).addClass('has-file');
            $remove.removeAttr('hidden');
        } else {
            $name.text($name.attr('data-placeholder') || PLACEHOLDER).removeClass('has-file');
            $remove.attr('hidden', 'hidden');
        }
    }

    $(function () {
        // Cache original placeholder so we can restore it after a clear.
        $('.js-attachName').each(function () {
            $(this).attr('data-placeholder', $(this).text());
        });

        $(document).on('change', '.js-attachInput', function () {
            refresh($(this));
        });

        $(document).on('click', '.js-attachRemove', function (e) {
            e.preventDefault();
            const $field = $(this).closest('.js-attachField');
            const $input = $field.find('.js-attachInput');
            $input.val('');
            refresh($input);
            $input.trigger('focus');
        });
    });
})(jQuery);
